<template>
    <pre v-pre>
&lt;script type="text/javascript"&gt;
    var event = event || window.event;
    alert("坐标：[" + event.clientX + ", " + event.clientY + "]")
&lt;/script&gt;
    </pre>
</template>
<script>
export default {
    name:'Navs',
    methods:{
        handleClick(event){
            alert("坐标：[" + event.clientX + ", " + event.clientY + "]")
        }
    },
    mounted(){
        document.addEventListener('click',this.handleClick)
    }
}
</script>
<style>
pre{
    color: green;
    padding: 10px 15px;
    background: #f0f0f0;
    border: 1px dotted #333;
    font: 12px/1.5 courier new;
}

</style>
